// ISAC4 OIDC configurations — public client with PKCE (no secret)
// Registered via support request ID-41436 (onboarding-RP)
// https://jira.infocert.it/browse/ID-41436

const baseConfig = {
  //scope: 'openid',
  scope: 'openid profile email',
  responseType: 'code',
  requireHttps: false,
  skipIssuerCheck: true,
  disablePKCE: false,
  // Nonce check disabilitato: con code flow + PKCE la protezione replay
  // è già garantita dal code_verifier. Il nonce è obbligatorio solo per
  // implicit flow (OIDC Core §3.1.2.1). Disabilitarlo evita il bug
  // "Wrong nonce" causato dalla rigenerazione interna della libreria
  // quando configure()+loadDiscoveryDocument() viene rieseguito al
  // caricamento della pagina di callback.
  disableNonceCheck: true,
};

const OAUTH2_CONFIG = (clientId: string, issuer: string, appUrl: string) => ({
  ...baseConfig,
  clientId,
  issuer,
  redirectUri: `${appUrl}/`,
  postLogoutRedirectUri: `${appUrl}/`,
});

export const oauth2Config = OAUTH2_CONFIG(
  'mysign-pr',
  'https://idp.infocert.it',
  'https://mysign.infocert.it'
);

export const oauth2Config_CL = OAUTH2_CONFIG(
  'mysign-cl',
  'https://idpcl.infocert.it',
  'https://mysigncl.infocert.it'
);

export const oauth2Config_SVTS = OAUTH2_CONFIG(
  'mysign-svts',
  'https://idp.eu-south-1.tsaws.infocert.it',
  'https://mysign.eu-south-1.tsaws.infocert.it'
);

// NOTA: richiedere al team ISAC di aggiungere http://localhost:4200
// e http://localhost:4200/ alle redirect URI del client mysign-svts
export const oauth2Config_LOCAL = OAUTH2_CONFIG(
  'mysign-cl',
  'https://idpcl.infocert.it',
  'http://localhost:4200'
);
